import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Segment, SegmentIcon, SegmentWidth } from './vertical-segments.model';

@Component({
  selector: 'cbre-vertical-segments',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./vertical-segments.component.scss'],
  template: `
    <div class="vs__elevator-container">
      <div
        *ngFor="let segIndex of segmentCountArr"
        [ngClass]="'vs__elevator-wrapper vs__elevator-wrapper--' + segmentWidth"
      >
        <div
          [ngClass]="
            !segmentsData[segIndex]?.hide
              ? 'vs__elevator vs__elevator--' + segmentsData[segIndex]?.variant
              : 'vs__elevator'
          "
        ></div>

        <ng-container *ngIf="segmentsData[segIndex]?.icon != null">
          <ng-container [ngSwitch]="segmentsData[segIndex].icon">
            <div
              *ngSwitchCase="segmentIconOpts.start"
              class="vs__elevator-icon vs__elevator-icon-start"
              [ngClass]="'vs__elevator-icon-start--' + segmentsData[segIndex]?.variant"
            >
              <span class="icon-ev-start"></span>
            </div>

            <div *ngSwitchDefault class="vs__elevator-icon vs__elevator-icon-stop">
              <mat-icon svgIcon="elevator" aria-hidden="false"></mat-icon>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  `,
  imports: [CommonModule, MatIconModule],
})
export class VerticalSegmentsComponent {
  /**
   * Data for the segments is a map where the key is the index of the segment that should be displayed and the value is the segment data
   * @type {Object.<number, Segment>}
   * @example
   * {
   *  0: { variant: SegmentVariant.Thick, icon: SegmentIcon.start },
   *  1: { variant: SegmentVariant.Thick, icon: SegmentIcon.stop },
   * }
   *
   * If the segment is not present in the map, it will be hidden
   * also the keys should match the segmentCount
   */
  @Input() segmentsData: { [key: number]: Segment } = {};
  /**
   * The number of segments to display
   * @type {number}
   */
  @Input() set segmentCount(count: number) {
    this.segmentCountArr = Array.from({ length: count }, (_, i) => i);
  }

  /**
   * The width of the segments
   * @type {SegmentWidth}
   */
  @Input() segmentWidth: SegmentWidth = SegmentWidth.Thick;

  public segmentIconOpts = SegmentIcon;
  public segmentCountArr: number[] = [];
}
